import { Component, Input } from '@angular/core';

@Component({
    selector: 'sgt-capital-social-form-control-text',
    templateUrl: './capital-social-form-control-text.component.html',
    styleUrls: ['./capital-social-form-control-text.component.less']
})
export class CapitalSocialFormControlTextComponent {
    @Input() label = 'Capital Social';
    @Input() helpText = 'Capital social da empresa';
    @Input() capitalSocial: number = null;
}
